import formatUrl from "utils/FormatUrl";
import styles from "./OffreProComponent.module.css";

const OffreProComponent = (props) => {
  return (
    <>
      <div
        className={styles.container}
        style={
          props.backgroundColor
            ? { backgroundColor: `${props.backgroundColor}` }
            : null
        }
      >
        <div
          className={styles.inner}
          style={{
            flexDirection: `${props.orientation_lr ? "row" : "row-reverse"}`,
          }}
        >
          <div className={styles.image__container}>
            <div className={styles.image__inner}>
              <img
                src={props.mainImage}
                alt={props.image_alt}
                className={styles.image}
              />
            </div>
          </div>
          <div className={styles.text__container}>
            <div className={styles.text_inner}>
              <div className={styles.text_only}>
                <p className={styles.title}>{props.title}</p>
                <p className={styles.texte}>{props.texte}</p>
                <p className={styles.texte}>{props.text2}</p>
              </div>
              <div className={styles.button__container}>
                <a
                  rel={
                    props.button_link?.includes("list") ||
                    props.button_link?.includes("map") ||
                    props.button_link?.includes("?") ||
                    props.button_link?.includes("conditions") ||
                    props.button_link?.includes("contact")
                      ? "noindex, nofollow, noreferrer"
                      : "dofollow"
                  }
                  href={formatUrl(`/${props.lang}${props.button_link}`)}
                  target="__blank"
                >
                  <p className={styles.button_link}>{props.button_text}</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OffreProComponent;
